import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideElementDirective } from './click-outside-element.directive';

@NgModule({
  declarations: [ClickOutsideElementDirective], // ✅ Declare the pipe here
  imports: [CommonModule], // ✅ Import CommonModule if required
  exports: [ClickOutsideElementDirective], // ✅ Export the pipe for use in other modules
})
export class OutSideClickModule {}
